
require.context('./imgs', true, /.*/); //copy whole imgs folder

import "./scss/styles.scss";

// import $ from 'jquery';
import "bootstrap-v5";
import "nette.ajax.js";
import "nette-forms";
import "jquery-inview";
import "@fancyapps/fancybox/dist/jquery.fancybox";
import "justifiedGallery/src/js/justifiedGallery";
import "../others/nette-ajax/spinner";
import "../others/startbox/js/controllers/show-on-scroll"
import "../others/startbox/js/controllers/navbar"
import "../others/startbox/js/controllers/swiper"

import "../others/startbox/js/controllers/others"
import "./js/cookiesConfirm"; //uncomment to use + set analytics
import "./js/payment";
import "./js/customerInfo";
import "./js/variantChanger";
import "./js/cartVariantChanger";
import "./js/antispam";
import "./js/inits";

window.Nette = require('nette-forms');
Nette.initOnLoad();
